import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { LegalPage } from '@components';
import { email, siteUrl } from '@config';

/**
 * ВНИМАНИЕ: настоящий текст является шаблоном и перед публикацией
 * должен быть проверен специалистом по законодательству РФ
 * о персональных данных (в т.ч. Федеральный закон № 152-ФЗ).
 * При необходимости добавьте подтверждённые реквизиты оператора.
 */
const PersonalDataPage = ({ location }) => (
  <LegalPage
    location={location}
    title="Обработка персональных данных"
    updated="14 мая 2026 г."
    description="Документ об обработке персональных данных оператором ИП Пушкарева Мария Викторовна: цели, правовые основания, порядок обработки и защиты данных.">
    <h2>1. Общие положения</h2>
    <p>
      Настоящий документ определяет политику оператора в отношении обработки персональных данных и
      порядок реализации мер, предусмотренных Федеральным законом от 27.07.2006 № 152-ФЗ «О
      персональных данных», применительно к сайту <strong>{siteUrl}</strong> (далее — Сайт).
    </p>
    <p>
      Документ действует в отношении всех персональных данных, которые оператор получает от
      пользователей Сайта. Документ размещён на отдельной странице и доступен в любое время.
    </p>

    <h2>2. Сведения об операторе</h2>
    <ul>
      <li>Оператор: индивидуальный предприниматель Пушкарева Мария Викторовна.</li>
      <li>Адрес электронной почты: {email}.</li>
    </ul>

    <h2>3. Перечень обрабатываемых персональных данных</h2>
    <p>
      Сайт не содержит регистрации, личного кабинета и форм, предназначенных для ввода
      персональных данных. Обработке могут подлежать:
    </p>
    <ul>
      <li>
        технические данные, автоматически передаваемые при обращении к Сайту (IP-адрес, сведения о
        браузере и устройстве, дата и время обращения, запрошенные страницы);
      </li>
      <li>
        данные, которые пользователь сообщает добровольно при направлении письма на адрес
        электронной почты оператора (имя, адрес электронной почты, содержание обращения).
      </li>
    </ul>
    <p>
      Оператор не обрабатывает специальные категории персональных данных и биометрические
      персональные данные.
    </p>

    <h2>4. Цели обработки персональных данных</h2>
    <ul>
      <li>обеспечение работы, доступности и безопасности Сайта;</li>
      <li>обработка обращений пользователей и направление ответов;</li>
      <li>подготовка и исполнение договоров на оказание услуг;</li>
      <li>исполнение обязанностей, возложенных на оператора законодательством Российской
        Федерации.</li>
    </ul>

    <h2>5. Правовые основания обработки</h2>
    <ul>
      <li>Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных»;</li>
      <li>согласие субъекта персональных данных;</li>
      <li>исполнение договора, стороной которого является субъект персональных данных.</li>
    </ul>

    <h2>6. Порядок и условия обработки</h2>
    <p>
      Обработка персональных данных осуществляется как с использованием средств автоматизации, так
      и без них. Оператор соблюдает принципы законности, ограничения обработки заранее заявленными
      целями, минимизации и точности данных, а также ограничения срока хранения.
    </p>
    <p>
      Оператор не осуществляет трансграничную передачу персональных данных. Для обеспечения работы
      Сайта может привлекаться хостинг-провайдер ([наименование хостинг-провайдера]), серверы
      которого расположены на территории Российской Федерации. Сайт не использует системы
      веб-аналитики, рекламные пиксели, CAPTCHA, карты и иные сторонние сервисы, собирающие
      персональные данные.
    </p>

    <h2>7. Согласие на обработку персональных данных</h2>
    <p>
      При обращении к оператору по электронной почте пользователь, направляя сообщение,
      подтверждает своё согласие на обработку указанных им персональных данных на условиях
      настоящего документа. Согласие даётся на совершение действий, направленных на обработку
      персональных данных, включая сбор, запись, систематизацию, хранение, уточнение,
      использование, передачу (в случаях, предусмотренных законом), блокирование, удаление и
      уничтожение.
    </p>
    <p>
      Согласие действует до достижения целей обработки либо до его отзыва субъектом персональных
      данных.
    </p>

    <h2>8. Сроки хранения персональных данных</h2>
    <p>
      Персональные данные хранятся не дольше, чем этого требуют цели их обработки. Технические
      журналы сервера хранятся в течение срока, необходимого для обеспечения безопасности и
      работоспособности Сайта. Данные обращений хранятся до достижения целей обработки либо до
      отзыва согласия, если законодательством не установлен иной срок.
    </p>

    <h2>9. Меры по защите персональных данных</h2>
    <p>Для защиты персональных данных оператор принимает, в частности, следующие меры:</p>
    <ul>
      <li>назначение ответственного за организацию обработки персональных данных;</li>
      <li>ограничение доступа к персональным данным;</li>
      <li>использование защищённых протоколов передачи данных (HTTPS);</li>
      <li>применение организационных и технических мер защиты информации;</li>
      <li>контроль за соблюдением условий обработки и защиты персональных данных.</li>
    </ul>

    <h2>10. Права субъекта персональных данных</h2>
    <ul>
      <li>получать сведения об обработке своих персональных данных;</li>
      <li>требовать уточнения, блокирования или уничтожения персональных данных;</li>
      <li>отозвать согласие на обработку персональных данных;</li>
      <li>обращаться в Роскомнадзор или в суд для защиты своих прав.</li>
    </ul>

    <h2>11. Порядок отзыва согласия и обращения</h2>
    <p>
      Отзыв согласия и любые обращения направляются на адрес электронной почты{' '}
      <strong>{email}</strong>. После получения отзыва согласия обработка
      персональных данных прекращается, а данные уничтожаются, если отсутствуют иные законные
      основания для обработки.
    </p>
    <p>
      Дополнительные сведения о порядке обработки данных приведены в разделе{' '}
      <Link to="/privacy">«Политика конфиденциальности»</Link>.
    </p>

    <h2>12. Заключительные положения</h2>
    <p>
      Оператор вправе вносить изменения в настоящий документ. Актуальная редакция размещается на
      данной странице. Контроль за исполнением настоящего документа осуществляет оператор.
    </p>

    <div className="requisites">
      <strong>Оператор:</strong>
      <p>
        ИП Пушкарева Мария Викторовна
        <br />
        E-mail: {email}
      </p>
    </div>
  </LegalPage>
);

PersonalDataPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default PersonalDataPage;
